import { ErrorCodeMap } from './error-code-map.type';

/**
 * auth-service `ExceptionErrorCodes` (range 9001-9039).
 * Generated from the backend registry; see error-codes.md.
 *
 * 9012 (companyInvalidId) is also thrown by InvalidEventIdException on the backend
 * (no dedicated event-id code), so the number is shared.
 */
export const AUTH_ERROR_CODES: ErrorCodeMap = {
  9001: { key: 'userNotFound', surface: true },
  9002: { key: 'refreshTokenExpired', surface: false },
  9003: { key: 'refreshTokenNotFound', surface: false },
  9004: { key: 'invalidUserRole', surface: true },
  9005: { key: 'invalidPasswordRequestToken', surface: false },
  9006: { key: 'passwordResetRequestTokenExpired', surface: false },
  9007: { key: 'facebookApiClientException', surface: false },
  9008: { key: 'invalidPassword', surface: true },
  9009: { key: 'sessionAlreadyFinished', surface: false },
  9010: { key: 'invalidJwt', surface: false },
  9011: { key: 'couldNotGetAppleSigninKeys', surface: false },
  9012: { key: 'companyInvalidId', surface: false },
  9013: { key: 'permissionInvalidId', surface: false },
  9014: { key: 'permissionInvalidName', surface: true },
  9015: { key: 'roleInvalidId', surface: false },
  9016: { key: 'roleInvalidName', surface: true },
  9017: { key: 'userCompanyCustomPermissionInvalidCreatedBy', surface: false },
  9018: { key: 'userCompanyCustomPermissionInvalidUpdatedBy', surface: false },
  9019: { key: 'userCompanyRoleInvalidCreatedBy', surface: false },
  9020: { key: 'userCompanyRoleInvalidUpdatedBy', surface: false },
  9021: { key: 'userCompanyRoleAlreadyExists', surface: true },
  9022: { key: 'roleNotFound', surface: true },
  9023: { key: 'companyNotFound', surface: true },
  9024: { key: 'permissionNotFound', surface: true },
  9025: { key: 'userCompanyCustomPermissionAlreadyExists', surface: true },
  9026: { key: 'eventNotFound', surface: true },
  9027: { key: 'clubInvalidId', surface: false },
  9028: { key: 'teamLeaderUserMissingTeams', surface: true },
  9029: { key: 'promoterUserMissingChannels', surface: true },
  9030: { key: 'invalidId', surface: false },
  9031: { key: 'invalidCreatedBy', surface: false },
  9032: { key: 'invalidDeletedBy', surface: false },
  9033: { key: 'invalidUpdatedBy', surface: false },
  9034: { key: 'externalUserWithoutEmail', surface: true },
  9035: { key: 'companyClubInvalidId', surface: false },
  9036: { key: 'missingRequiredPermissionsForXceedAccess', surface: true },
  9037: { key: 'userMustSwitchToXceedPro', surface: true },
  9038: { key: 'userMustSwitchToXceedB2c', surface: true },
  9039: { key: 'userServiceApiClientException', surface: false },
};
